import React, { useState } from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const VisitorReport = ({ data }) => {
  const [viewType, setViewType] = useState("country");

  // Function to aggregate counts based on the selected view type
  const getCounts = (level) => {
    const counts = data.reduce((acc, curr) => {
      const location = curr[level];
      const name = typeof location === "object" ? location?.name : location;
      if (!name) return acc;
      acc[name] = (acc[name] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(counts)
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count);
  };

  const counts = getCounts(viewType);

  // Dynamically calculate chart width based on number of items (min 600px, 80px per bar)
  const chartWidth = Math.max(600, counts.length * 80);

  return (
    <Box
      sx={{ p: 3, border: "1px solid #e0e0e0", borderRadius: 2, width: "100%" }}
    >
      <Typography variant="h6" gutterBottom>
        Visitor Distribution
      </Typography>

      <FormControl sx={{ mb: 2, maxWidth: 300 }}>
        <InputLabel>View Type</InputLabel>
        <Select
          value={viewType}
          onChange={(e) => setViewType(e.target.value)}
          label="View Type"
        >
          <MenuItem value="country">Country-wise</MenuItem>
          <MenuItem value="state">State-wise</MenuItem>
          <MenuItem value="city">City-wise</MenuItem>
        </Select>
      </FormControl>

      {counts.length > 0 ? (
        <Box
          sx={{
            width: "100%",
            height: 400,
            overflowX: "auto",
            overflowY: "hidden",
            "&::-webkit-scrollbar": {
              height: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          <Box sx={{ width: chartWidth, height: "100%" }}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={counts}
                margin={{ top: 20, right: 30, left: 20, bottom: 120 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="name"
                  angle={-45}
                  textAnchor="end"
                  interval={0}
                  height={100}
                  tick={{ fontSize: 12, width: 150, wordBreak: "break-word" }}
                  tickMargin={10}
                />
                <YAxis allowDecimals={false} />
                <Tooltip />
                <Bar
                  dataKey="count"
                  fill="#1976d2"
                  name="Visitors"
                  maxBarSize={40}
                  minPointSize={5}
                />
              </BarChart>
            </ResponsiveContainer>
          </Box>
        </Box>
      ) : (
        <Typography variant="body1" sx={{ textAlign: "center", p: 3 }}>
          No data available for selected view
        </Typography>
      )}
    </Box>
  );
};

export default VisitorReport;
